import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getOrdersAdmin, updateStatusOrder } from "../function/admin";
import { toast } from "react-toastify";
import { Table, Button, Input } from "antd";
import PaymentProofPopup from "../page/admin/PaymentProofPopup";
import DownloadPopup from "../page/admin/DownloadPopup";

const { Search } = Input;

const StockOrders = () => {
  const { user } = useSelector((state) => ({ ...state }));
  const [orders, setOrders] = useState([]);
  const [popupVisible, setPopupVisible] = useState(false);
  const [downloadPopupVisible, setDownloadPopupVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    getOrdersAdmin(user.token).then((res) => {
      // filter เฉพาะ Completed + homeDelivery
      const filtered = res.data.filter(
        (o) => ["Shipping", "Delivered", "Completed"].includes(o.orderstatus) && o.deliveryMethod === "homeDelivery"
      );
      const sortedOrders = filtered.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setOrders(sortedOrders);
    });
  };

  const handleChangeStatus = (orderId, orderstatus) => {
    updateStatusOrder(user.token, orderId, orderstatus).then((res) => {
      toast.info("Updated " + res.data.orderstatus + " Success");
      loadData();
    });
  };

  const handleOpenPopup = (order) => {
    setSelectedOrder(order);
    setPopupVisible(true);
  };

  const handleClosePopup = () => setPopupVisible(false);

  const handleOpenDownloadPopup = (order) => {
    setSelectedOrder(order);
    setDownloadPopupVisible(true);
  };

  const handleCloseDownloadPopup = () => setDownloadPopupVisible(false);

  const filteredOrders = orders.filter((order) =>
    order.orderNumber && order.orderNumber.includes(searchTerm)
  );

  const columns = [
    { title: "ลำดับ", dataIndex: "index", render: (text, record, index) => index + 1, width: 80 },
    { title: "ชื่อผู้ใช้", dataIndex: "orderdBy", render: (item) => item?.username || "No user" },
    { title: "Reference Number", dataIndex: "referenceNumber" },
    {
      title: "วันที่",
      dataIndex: "createdAt",
      render: (date) => new Date(date).toLocaleDateString("th-TH"),
    },
    {
      title: "รายการสินค้า",
      dataIndex: "products",
      render: (products) => (
        <ol>
          {products.map((p) => (
            <li key={p.product?._id}>
              {p.product ? p.product.title || "No title" : "สินค้าถูกลบ"}{" "}
              <b>{p.price} x {p.count}</b>
            </li>
          ))}
        </ol>
      ),
    },
    { title: "ราคารวมสุทธิ", dataIndex: "cartTotal" },
    {
      title: "หลักฐานการชำระเงิน",
      render: (record) => <Button onClick={() => handleOpenPopup(record)}>View</Button>,
    },
    {
      title: "ที่อยู่จัดส่ง",
      render: (record) => <Button onClick={() => handleOpenDownloadPopup(record)}>Download Invoice</Button>,
    },
    {
      title: "อัพเดทสถานะ",
      render: (record) => (
        <select
          value={record.orderstatus}
          onChange={(e) => handleChangeStatus(record._id, e.target.value)}
          style={{ width: "200px" }}
        >
          <option value="Not Process" disabled>ยังไม่ดำเนินการ</option>
          <option value="Processing" disabled>กำลังดำเนินการ</option>
          <option value="Shipping" >กำลังจัดส่ง</option>
          <option value="Delivered" >จัดส่งแล้ว</option>
          <option value="Completed" >เสร็จสิ้น</option>
          <option value="Cancelled" disabled>ยกเลิก</option>
        </select>
      ),
    },
  ];

  return (
    <div className="container-fluid">
      <div className="row mt-1">
        <div className="col-md-3 mt-5">
          <h2>รายการสั่งซื้อ (Stock)</h2>
        </div>
        
      </div>
      
      <Search
        placeholder="ค้นหาด้วย Order Number"
        onSearch={(value) => setSearchTerm(value)}
        enterButton
        style={{ width: 300, marginBottom: 20 }}
      />
      <div className="col-md-12">
        <Table
        dataSource={filteredOrders}
        columns={columns}
        rowKey="_id"
        pagination={{ pageSize: 10 }} // ✅ ใส่ pagination จะลด re-render
        scroll={{ x: true }} // ✅ ใช้ true แทน "max-content"
        bordered // ✅ เพิ่ม border ช่วย stabilize layout
      />
      </div>
      

      <PaymentProofPopup
        visible={popupVisible}
        onClose={handleClosePopup}
        order={selectedOrder}
      />

      {selectedOrder && (
        <DownloadPopup
          visible={downloadPopupVisible}
          onClose={handleCloseDownloadPopup}
          order={selectedOrder}
        />
      )}
    </div>
  );
};

export default StockOrders;

